import React from "react"
import Layout from "../component/layout"
export default () => (
  <Layout>
    <h1>Blog post number ONE</h1>
    <h2>I'm so sick, both my parents had to be doctors in order for me to survive</h2>
  </Layout>
  )